export function secondsToScore(seconds: number): number {
  if (seconds <= 60) {
    return 550;
  } else if (seconds <= 90) {
    return 500;
  } else if (seconds <= 120) {
    return 350;
  } else if (seconds <= 150) {
    return 300;
  } else if (seconds <= 180) {
    return 200;
  } else if (seconds <= 210) {
    return 100;
  } else {
    return 10;
  }
}
